/**
 * Render a description that may be:
 *  - HTML (from the TipTap editor): rendered as-is with safe styling
 *  - Plain text (legacy): rendered with whitespace preserved
 */
export function RichText({ html, className = '', testId }) {
  if (!html) return null;
  const looksLikeHtml = /<\/?(p|ul|ol|li|strong|em|b|br)\b/i.test(html);

  if (looksLikeHtml) {
    return (
      <div
        className={`rich-text-content ${className}`}
        data-testid={testId}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }

  return (
    <p
      className={`rich-text-content whitespace-pre-wrap ${className}`}
      data-testid={testId}
    >
      {html}
    </p>
  );
}
